// Shared helper for task card CSS classes based on service type and urgency.

export const getTaskCardClasses = (task) => {
  const baseClass = "reversia-card reversia-card-with-stripe";

  let serviceClass = "";
  switch (task.service_type) {
    case "secret_shopper":
      serviceClass = "reversia-card-secret-shopper";
      break;
    case "grave_care":
      serviceClass = "reversia-card-grave-care";
      break;
    case "mobile_journalist":
      serviceClass = "reversia-card-mobile-journalist";
      break;
    case "general":
    default:
      serviceClass = "reversia-card-general";
      break;
  }

  let urgencyClass = "";
  if (task.service_type === "mobile_journalist" && task.urgency_level === "urgent") {
    urgencyClass = "reversia-card-urgent";
  }

  return `${baseClass} ${serviceClass} ${urgencyClass}`.trim();
};
